import React, { useState } from 'react';
import PropTypes from "prop-types"
import Img from "gatsby-image"

import {
	RiArrowLeftSLine,
	RiArrowRightSLine } from 'react-icons/ri'

export default function ProductImages( props ) {

	const { images } = props;
	const totalImages = images.length;

	const [ state, setState ] = useState({
		mainImage: images[ 0 ],
		currentIndex: 0
	})

	const handlePhotoChange = ( event ) => {
		const imageId = parseInt( event.target.getAttribute( 'data-image-id' ) );
		if ( state.mainImage.id === imageId ) {
			return
		}

		images.forEach( ( image, index ) => {
			if ( parseInt( image.id ) === imageId ) {
				setState({
					mainImage: image,
					currentIndex: index
				})
			}
		} )
	}

	const handleButtonClick = ( increment ) => {
		setState({
			mainImage: images[ state.currentIndex + increment ],
			currentIndex: state.currentIndex + increment
		});
	}

	return (
		<div className="product-images">
			<div className="product-images__main">
				<RiArrowLeftSLine
					className={`product-images__button product-images__button--prev ${ !state.currentIndex ? 'disabled' : '' }`}
					onClick={ () => handleButtonClick( -1 ) }
					/>
				<Img className="product-images__thumbnail-image active" fluid={ state.mainImage.imageFile.childImageSharp.fluid } />
				<RiArrowRightSLine
					className={`product-images__button product-images__button--next ${ state.currentIndex + 1 === totalImages ? 'disabled' : '' }`}
					onClick={ () => handleButtonClick( 1 ) }
					/>
			</div>

			<div className={`product-images__thumbnails-wrapper product-images__thumbnails-wrapper--${ totalImages }`}>
				{ images.map( ( image, index ) => {
					return (
						<button
							className={`product-images__thumbnail-container ${ state.currentIndex === index ? 'active' : '' }`}
							data-image-id={ image.id }
							onClick={ e => handlePhotoChange( e ) }
							key={ image.id }
						>
							<Img className="product-images__thumbnail-image" fluid={ image.imageFile.childImageSharp.fluid } />
						</button>
					)
				} ) }
			</div>
		</div>
	)
}

ProductImages.propTypes = {
	images: PropTypes.array,
	productInStock: PropTypes.number
}